import { useMemo } from 'react';

import { normalizeUrl } from 'core/Utils';
import { ActionIcon, Group } from 'ui';
import { IconFacebook, IconInstagram, IconLink, IconLinkedIn, IconXTwitter } from 'ui/Icons';

import { useCausePageContext } from '../../CauseContext';

const AboutLinks = () => {
  const { cause } = useCausePageContext();

  const linkIconMap = useMemo(
    () =>
      new Map<string, React.ReactNode>([
        ['website', <IconLink key="website" />],
        ['facebook', <IconFacebook key="facebook" />],
        ['linkedin', <IconLinkedIn key="linkedin" />],
        ['twitter', <IconXTwitter key="xtwitter" />],
        ['instagram', <IconInstagram key="instagram" />],
      ]),
    []
  );

  const links = useMemo(() => {
    if (!cause.links) return [];

    return (
      cause.links
        // We don't need to show the website link, it's already shown in the cause page header
        .filter((link) => !!link.url && link.type !== 'website')
        .map((link) => {
          return {
            type: link.type,
            icon: linkIconMap.get(link.type),
            href: normalizeUrl(link.url),
          };
        })
    );
  }, [cause.links, linkIconMap]);

  if (!links?.length) return null;

  return (
    <Group gap="8">
      {links?.map(({ icon, type, href }) => (
        <ActionIcon key={type} component="a" href={href} target="_blank" variant="gray" size="md">
          {icon}
        </ActionIcon>
      ))}
    </Group>
  );
};

export { AboutLinks };
